import styled from 'styled-components';
import { Typography } from 'antd';
import { blue01, blueDark01, grayDark03, grayDark06, grayLight03 } from '../../styles/colors';

export const NotificationsEmailText = styled(Typography.Text)`
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${grayDark03};
    padding-left: 10px;
`;

export const SectionTitle = styled.div`
    font-family: 'DINNextLTPro';
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: ${blue01};
    margin-bottom: 8px;
`;

export const NotificationsEmailTable = styled('table')`
    margin-top: 30px;
    width: 100%;
    padding-left: 10px;
    table-layout: fixed;
    border-collapse: collapse;

    tbody {
        tr {
            border-bottom: 1px solid ${grayLight03};
        }

        td {
            vertical-align: middle;
        }
    }

    thead {
        border-bottom: 1px solid ${grayDark06};

        td {
            vertical-align: bottom;
        }
    }

    td:first-child {
        width: 56%;
    }

    td:nth-child(2) {
        width: 22%;
        text-align: center;
    }

    td:nth-child(3) {
        width: 22%;
        text-align: center;
    }
`;

export const NotificationsTableTitle = styled('span')`
    font-weight: normal;
    font-family: 'Proxima N W15 Bold';
    font-size: 14px;
    line-height: 18px;
    color: ${blueDark01};
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    width: 100%;
`;

export const NotificationTip = styled('div')`
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    position: absolute;
    white-space: nowrap;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.5;
    font-family: 'Proxima Nova';
`;

export const CheckBoxContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 10px 0;
`;
